import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,
  validateNumberLength,TableDatePicker} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';
import {Comp_Add_Product_Master} from '../components/comp_add_product_master'
// import {Comp_Add_Party_Info} from '../components/comp_add_party_info';
import {Comp_Add_STO} from '../components/comp_add_sto';
import {Comp_Add_Accessibility} from '../components/comp_add_accessibility';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';


import defaultPic from '../assets/images/9.png';

//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';


let loginUser="";
let userObject="";
let companyName="";
let clsViewEmployee;

let rf="0";

let _objAccess={};
class View_STO extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
          _objAccess=getAccessFunctions();
      }
      this.state={ listUsers:[],stEditUser:{},stListAccessibility:[]};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsViewEmployee=this;
      }

      getAssignAccessibility(item){
        let map=[];
        map.push({name:"curl_type",value:"get_master_access"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"req_user_id",value:btoa(item.id)});
        //map.push({name:"ser_userType",value:$("#ser_userType").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        map.push({name:"upper_id",value:userObject[0].upper_id});
        
        map["res_func"]="callBackrrr";
        map["curl_type"]="get_master_access";
        CallMapMethod_CBack(clsViewEmployee,map,function(data,msg){
          //alert(data);
          if(data!=="0" && data!==""){
            let lsData=JSON.parse(data);
            clsViewEmployee.setState({stListAccessibility:lsData["list_module"],stEditUser:item});
            

          }
        })

      }
      getOfficersSync(){
        var map=[];
        map.push({name:"curl_type",value:"VersionDataSync"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"upper_id",value:userObject[0].upper_id});
       
        map.push({name:"sync_type",value:"officer_master"});
       
        map["res_func"]="callBackrrr";
        map["curl_type"]="VersionDataSync";
        CallMapMethod_CBack(clsViewEmployee,map,function(data,msg){
          if(data!=="0"){
            let syncData=JSON.parse(data);
            let officerMaster=syncData.officer_master;
            //alert(JSON.stringify(officerMaster));
            if (window.memc_system){
              let respStudy=  window.memc_system.getBulkOfficerImport(JSON.stringify(officerMaster));
              //alert(respStudy);
              Custom_Alert("View",respStudy,true);
            }

          }

        })

      }

      SendApprovalRequest(){
        //alert("i m in server req");
        let mapNew=[];
        mapNew.push({name:"curl_type",value:"getSTO_CTO_OffSync"});
        mapNew.push({name:"res_func",value:"callBackrrr"});
        mapNew.push({name:"local_token",value:userObject[0].id});
        mapNew.push({name:"user_type",value:userObject[0].type});
        mapNew.push({name:"ls_officers",value:btoa(JSON.stringify(clsViewEmployee.state.listUsers))});

        mapNew["res_func"]="callBackrrr";
        mapNew["curl_type"]="getSTO_CTO_OffSync";
        
        CallMapMethod_CBack(clsViewEmployee,mapNew,function(data,msg){

        });

        
        Custom_Alert("Option not available","Not available to sync",false);
      }

      getSTO_CTO_Off(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getSTO_CTO_Off"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"type_master_id",value:btoa("11")});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        
        
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getSTO_CTO_Off";
        CallMapMethod_CBack(clsViewEmployee,map,function(data,msg){
          //alert(msg);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                clsViewEmployee.setState({listUsers:listData},()=>{
                  //window.getPagination("#tbData");
                  clsViewEmployee.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                 
                  if(rf!=="0"){
                    clsViewEmployee.getSearch(rf);
                    //alert("i m in setup "+rf);
                    $("#serLoanStatus").val(rf);
                  }
                });
              }
        });
      }
      okRespCreateUser(data,msg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful",msg,true);
          //clsViewEmployee.getUserInfo();
          //$("#frmAddSTO").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Not Working",msg,false);
        }
        // alert(data);
      }


setEditUserInfo(item){
  // method will work on click on Credit Button Link to set State
  clsViewEmployee.setState({stEditUser:item},()=>{
    
  })

 }             
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getSTO_CTO_Off();

$('#divAddSTO').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  //clsViewEmployee.setState({stFeeCategory:{"nn":"00"}});
  //clsViewEmployee.forceUpdateHandler();
  clsViewEmployee.getSTO_CTO_Off();
 
});
$('#divAddSTO').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  //clsViewEmployee.setState({stFeeCategory:{"nn":"00"}});
  //clsViewEmployee.forceUpdateHandler();
  clsViewEmployee.getSTO_CTO_Off();
 
});
}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">

<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan1">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>List Shipboard Training Officers</b></h3>
                <div className="row content12 mt11-2 mb11-2">


<div className='col-lg-4 col-md-4 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_text" name="ser_text" className="_setSearchKeyUp form-control form-control-sm" placeholder='search' />
             </div>
         
         </div>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
               
                 <div onClick={()=>this.getSTO_CTO_Off()}  style={{marginRight:"10px"}} className="btn btn-sm btn-primay">Search</div>
                 <div onClick={()=>window.location.reload()} className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>

</div>
{window.memc_system?<div className='col-md-2'>
<button onClick={()=>this.getOfficersSync()}  style={{marginRight:"10px"}} className="btn btn-sm btn-primary">Get Officers(Online)</button>
</div>:''}
{window.memc_system?<div className='col-md-2'>
<button onClick={()=>this.SendApprovalRequest()}  style={{marginRight:"10px"}} className="btn btn-sm btn-secondary">Sync Online</button>
</div>:''}
<div class="col-md-2">
<a className="btn btn-sm btn-danger float-right" onClick={()=>this.setEditUserInfo({})} data-bs-toggle="modal" data-bs-target="#divAddSTO" data-toggle="modal" data-target="#divAddSTO" href="javascript:void(0)">Add New</a>
</div>

    </div>    
                
                
              </div>
                <table id="tbData" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>Creation Date</th>
                      <th>STO Name</th>
                      
                      <th>STO Contact No</th>
                      <th>STO eMail</th>
                      <th>Owner/Company Name</th>
                      <th>Vessel Name(IMO No.)</th>
                      <th>COC No.</th>
                      <th>COC Grade</th>
                      <th>CDC No.</th>
                      <th>Indos No.</th>
                      <th>SignIn/Signing Off</th>
                      <th>Digital Sign</th>
                      <th>Is Synced</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.listUsers.map((item,index)=>{
                    let noSign=0;
                    if(item["sign_copy1"]!==""){
                      noSign++;
                    }
                    if(item["sign_copy2"]!==""){
                      noSign++;
                    }
                       return(<tr>
                        <td>{index+1}</td>
                  <td>{item["entry_date"]}</td>      
                  <td>{item["person_name"]}</td>
                  <td>{item["contact_no"]}</td>
                  <td>{item["email"]}</td>
                  <td>{item["company_name"]}</td>
                  <td>{item["ship_name"]+"("+item["imo_no"]+")"}</td>
                  <td>{item["coc_number"]}</td>
                  <td>{item["coc_grade"]}</td>
                  <td>{item["cdc_number"]}</td>
                  <td>{item["indos_number"]}</td>
                  <td>{item["doj"]+"/"+item["dos"]}</td>
                  <td>{"Signed Stamp Nos("+noSign+")"}</td>
                {/* <td>{item["digital_code"]}</td> */}
                  {/* <td>{item["address"]}</td> */}
                 
                  <td>{item.synced_status}</td>
                  <td>
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" data-toggle="dropdown" area-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                    {typeof _objAccess.can_edit!=="undefined"?<a class="dropdown-item" onClick={()=>this.setEditUserInfo(item)} data-bs-toggle="modal" data-bs-target="#divAddEmployee" data-toggle="modal" data-target="#divAddEmployee" href="javascript:void(0)">View/Edit</a>:''}
                    {typeof _objAccess.can_user_access!=="undefined"?<a class="dropdown-item" onClick={()=>this.getAssignAccessibility(item)} data-bs-toggle="modal" data-bs-target="#divAddAccessibility" data-toggle="modal"  data-target="#divAddAccessibility" href="javascript:void(0)">Accessibility</a>:''}
                    </div>
                  </div>
    </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
                <div class='pagination-container' >
				<nav>
				  <ul class="pagination">
            
            <li data-page="prev" >
								     <span> {"<"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  
        <li data-page="next" id="prev">
								       <span> {">"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  </ul>
				</nav>
			</div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>
<Comp_Add_Accessibility editUser={this.state.stEditUser} listAccessibility={this.state.stListAccessibility} logUser={userObject} />
<Comp_Add_STO editUser={this.state.stEditUser} logUser={userObject}/>

    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default View_STO;